import { createContext, useState } from "react";

export const HomepageContext = createContext(null)